import { AccessRightsService } from './access-rights.service';

export default angular
  .module('sfMobile.services.access-rights', [])
  .service('accessRightsService', AccessRightsService).name;
